import queryClient from "api/queryClient.ts";
import { getUserQueryOptions } from "api/TenantSlug/User/queryOptions.ts";
import { PerformanceReport } from "components/Report/PerformanceReport/PerformanceReport.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/"
)({
    component: AffiliateReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportAffiliate],
        showInSideMenu: false,
        label: "pages.report.affiliate.detail",
    },
    loader: async ({ params }: { params: { userId: string } }) => {
        let breadcrumb = params.userId;

        try {
            const { user } = await queryClient.ensureQueryData(getUserQueryOptions(params.userId, {}));

            breadcrumb = user?.nickname || user?.email || breadcrumb;
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
        };
    },
});

function AffiliateReportPage() {
    const { userId } = Route.useParams();
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems}>
            <PerformanceReport userId={userId} />
        </TenantPage>
    );
}
